import {
  type FC, useMemo,
} from 'react';
import {
  getDropdownNumericOptions, RegularDropdownComponent,
} from '~/_shared/baseComponents/dropdown';
import { noop } from '~/_shared/utils/function.helpers';
import { BOUNDARY_SETTINGS_MIN_RANGES_COUNT } from '../boundarySettings.common';

type NumberOfRangesDropdownProps = Readonly<{
  maxNumberOfRanges: number;
  numberOfRanges: number;
  onNumberOfRangesChange: (range: number) => void;
}>;

export const NumberOfRangesDropdownComponent: FC<NumberOfRangesDropdownProps> = ({
  maxNumberOfRanges,
  numberOfRanges,
  onNumberOfRangesChange,
}) => {
  const numberOfRangeOptions = useMemo(() => getDropdownNumericOptions(BOUNDARY_SETTINGS_MIN_RANGES_COUNT,
    maxNumberOfRanges), [maxNumberOfRanges]);

  return (
    <RegularDropdownComponent<number>
      onChange={onNumberOfRangesChange ?? noop}
      value={numberOfRanges}
      options={numberOfRangeOptions}
    />
  );
};
